import React from 'react';

import useTrafficSelectable from 'core/hooks/useTrafficSelectable';
import { Traffic } from 'core/types/traffic';

type Props = {
  id: Traffic['id'];
};

export default function VehicleTraffic({ id }: Props) {
  const traffic = useTrafficSelectable();

  if (traffic.length === 0) {
    return <>Ladataan...</>;
  }

  const t = traffic.find(t => t.id === id);

  return <>{t ? t.name : 'Tuntematon kuorma'}</>;
}
